import { render, staticRenderFns } from "./data-state-handler.vue?vue&type=template&id=4e955c81&scoped=true"
import script from "./data-state-handler.vue?vue&type=script&lang=ts"
export * from "./data-state-handler.vue?vue&type=script&lang=ts"
import style0 from "./data-state-handler.vue?vue&type=style&index=0&id=4e955c81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e955c81",
  null
  
)

export default component.exports